import AdBlockDetectedModal from './AdBlockDetectedModal'
import AddDeliveryCompanyModal from './AddDeliveryCompanyModal'
import AddManufacturerModal from './AddManufacturerModal'
import AddRackModal from './AddRackModal'
import AddShortageModal from './AddShortageModal'
import AddShortageOrderModal from './AddShortageOrderModal'
import AddUserModal from './AddUserModal'
import AddVariantModal from './AddVariantModal'
import AddWorkModal from './AddWorkModal'
import AuditLogDetailsModal from './AuditLogDetailsModal'
import CheckOrderHistoryModal from './CheckOrderHistoryModal'
import DispatchParcelsModal from './DispatchParcelsModal'
import FulfillShortageOrderModal from './FulfillShortageOrderModal'
import GetNumberForOrderModal from './GetNumberForOrderModal'
import MovePlaceModal from './MovePlaceModal'
import OrderEmailsModal from './OrderEmailsModal'
import OrderItemModal from './OrderItemModal'
import OrderShortagesModal from './OrderShortagesModal'
import SendShortageOrderEmailModal from './SendShortageOrderEmailModal'
import ShortagesModal from './ShortagesModal'
import TakeProductModal from './TakeProductModal'
import UpdateDeliveryCompanyModal from './UpdateDeliveryCompanyModal'
import UpdateManufacturerModal from './UpdateManufacturerModal'
import UpdatePasswordModal from './UpdatePasswordModal'
import UpdatePlaceConfigModal from './UpdatePlaceConfigModal'
import UpdateProductModal from './UpdateProductModal'
import UpdateShortageModal from './UpdateShortageModal'
import UpdateShortageOrderModal from './UpdateShortageOrderModal'
import UpdateUserModal from './UpdateUserModal'
import UpdateVariantModal from './UpdateVariantModal'
import UpdateWorkModal from './UpdateWorkModal'

export const modals = {
  adBlockDetected: AdBlockDetectedModal,
  addUser: AddUserModal,
  updateUser: UpdateUserModal,
  updatePassword: UpdatePasswordModal,
  takeProduct: TakeProductModal,
  movePlace: MovePlaceModal,
  editVariant: UpdateVariantModal,
  addVariant: AddVariantModal,
  editProduct: UpdateProductModal,
  addWork: AddWorkModal,
  updateWork: UpdateWorkModal,
  addShortage: AddShortageModal,
  updateShortage: UpdateShortageModal,
  addManufacturer: AddManufacturerModal,
  updateManufacturer: UpdateManufacturerModal,
  checkOrderHistory: CheckOrderHistoryModal,
  historyDetails: AuditLogDetailsModal,
  addRack: AddRackModal,
  updatePlaceConfig: UpdatePlaceConfigModal,
  orderShortages: OrderShortagesModal,
  addShortageOrder: AddShortageOrderModal,
  sendShortageOrderEmail: SendShortageOrderEmailModal,
  fulfillShortageOrder: FulfillShortageOrderModal,
  updateShortageOrder: UpdateShortageOrderModal,
  orderItem: OrderItemModal,
  addDeliveryCompany: AddDeliveryCompanyModal,
  updateDeliveryCompany: UpdateDeliveryCompanyModal,
  dispatchParcels: DispatchParcelsModal,
  getNumberForOrder: GetNumberForOrderModal,
  orderEmails: OrderEmailsModal,
  shortages: ShortagesModal,
}
